import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Steps, Button } from 'antd';
import IntegrationImage from '../images/Integration.png';
import RoutingImage from '../images/routing.png';
import ClearingImage from '../images/clearing.png';
import ConfirmationImage from '../images/instant.png';
import { Container } from '../styles/styled';

const HowitWorksWrapper = styled.div`
    padding: 80px 0;
    
    h2 {
        font-size: 36px;
        color: #002DFF;
        margin-bottom: 40px;
    }
    
    .ant-steps {
        margin-bottom: 50px;
    }
    
    .ant-steps-item-finish .ant-steps-item-icon {
        background-color: #29f0b4ff;
        border-color: #29f0b4ff;
    }
    
    .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
        color: #002DFF;
    }
    
    .ant-steps-item-active .ant-steps-item-icon {
        background-color: #29f0b4ff;
        border-color: #29f0b4ff;
    }
    
    .ant-steps-item-active .ant-steps-item-icon > .ant-steps-icon {
        color: #002DFF;
    }
    
    .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-tail::after {
        background-color: #29f0b4ff;
    }
`;

const ContentArea = styled.div`
    text-align: center;
    min-height: 400px;

    img {
        max-width: 100%;
        height: auto;
        margin-bottom: 30px;
        transition: opacity 0.2s ease-in-out, transform 0.2s ease-in-out;
    }
    
    h3 {
        color: #002DFF;
        font-size: 24px;
        margin-bottom: 20px;
    }
    
    p {
        color: #666;
        font-size: 16px;
        max-width: 600px;
        margin: 0 auto 30px;
    }

    .general-desc {
        font-style: italic;
        color: #777;
        max-width: 600px;
        margin: 30px auto 0;
    }
`;

const ButtonGroup = styled.div`
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-top: 30px;
    
    .ant-btn {
        height: 45px;
        padding: 0 30px;
        font-size: 18px;
        border-radius: 10px;
        font-weight: 500;
    }
    
    .ant-btn-primary {
        background-color: #29f0b4ff;
        border-color: #29f0b4ff;
        color: #002DFF;
        
        &:hover {
            background-color: #16dea2ff;
            border-color: #16dea2ff;
            color: #002DFF;
        }
    }
    
    .ant-btn-default {
        border-color: #29f0b4ff;
        color: #002DFF;
        
        &:hover {
            background-color: #29f0b4ff;
            border-color: #29f0b4ff;
            color: #002DFF;
        }
    }
`;

const HowItWorks = () => {
    const { t } = useTranslation('common');
    const [current, setCurrent] = useState(0);

    const steps = [
        {
            title: t('howItWorks.step.integration.title'),
            description: t('howItWorks.step.integration.description'),
            image: IntegrationImage
        },
        {
            title: t('howItWorks.step.routing.title'),
            description: t('howItWorks.step.routing.description'),
            image: RoutingImage
        },
        {
            title: t('howItWorks.step.clearing.title'),
            description: t('howItWorks.step.clearing.description'),
            image: ClearingImage
        },
        {
            title: t('howItWorks.step.confirmation.title'),
            description: t('howItWorks.step.confirmation.description'),
            image: ConfirmationImage
        }
    ];

    const next = () => {
        setCurrent(current + 1);
    };

    const prev = () => {
        setCurrent(current - 1);
    };

    const onChange = (value) => {
        setCurrent(value);
    };

    const items = steps.map((item) => ({
        title: item.title,
    }));

    return (
        <HowitWorksWrapper>
            <Container>
                <span style={{ 
                    backgroundColor: '#78FFD6', 
                    height: 'fit-content', 
                    borderRadius: '8px', 
                    display: 'block', 
                    width: '140px', 
                    color: '#78FFD6', 
                    fontSize: '37px', 
                    marginBottom: '-45px', 
                    marginLeft: '-10px' 
                }}>
                    S
                </span>
                <h2>{t('howItWorks.title')}</h2>
                
                <Steps 
                    current={current} 
                    onChange={onChange}
                    items={items}
                />

                <ContentArea>
                    <img style={{height:"200px"}} src={steps[current].image} alt={steps[current].title} />
                    <h3>{steps[current].description}</h3>
                    
                    <ButtonGroup>
                        {current > 0 && (
                            <Button onClick={prev}>
                                {t('howItWorks.previous')}
                            </Button>
                        )}
                        {current < steps.length - 1 && (
                            <Button type="primary" onClick={next}>
                                {t('howItWorks.nextStep')}
                            </Button>
                        )}
                        {current === steps.length - 1 && (
                            <Button type="primary">
                                {t('howItWorks.getStarted')}
                            </Button>
                        )}
                    </ButtonGroup>

                    <p className="general-desc">
                        {t('howItWorks.generalDesc')}
                    </p>
                </ContentArea>
            </Container>
        </HowitWorksWrapper>
    );
}

export default HowItWorks;